<template>
  <div class="w-full h-full bg-gray-200 dark:bg-gray-900">
    <!-- Yan Paneller -->
    <SideBarItem
      @selected="handleFleetSelected"
      @selectedGroup="handleGroupSelected"
      @selectedItem="setPlaqueSelected"
      @closeModal="resetItemDetail"
      @changeIntervention="updateInterventionStatus"
      @changeInterventionList="updateInterventionList"
    />
    <!-- ARAÇ DETAY -->
    <ProductSideBarItem
      @backMenu="backProduct"
      ref="prodDetail"
      :detail="detail"
      :isVehicleDetailShow="isVehicleDetailShow"
      @closeModal="
        () => {
          detail = {};
          resetItemDetail();
          isVehicleDetailShow = false;
        }
      "
      @selectedActiveDetail="updateActiveDetail"
    />

    <FilterPanel :detail="filter" ref="filterPanel" @change="updateFilters" />

    <GroupDetailPanel
      @close="resetItemDetail"
      :List="hoverList"
      :type="hoverListType"
      v-if="hoverList.length"
      @selected="setPlaqueSelected"
    />

    <!-- Detay Modal -->
    <detailModal :detailList="markers" />

    <!-- Kontrol Butonları -->
    <MapControls
      :showZones="showZones"
      :showFactories="showFactories"
      :search="search"
      @toggleZones="toggleZones"
      @toggleFactories="toggleFactories"
      @searchChanged="updateSearch"
      @changeSeachVal="(v)=> { search = v }"
      @searchSubmitted="performSearchOnEnter"
      @openFilterPanel="openFilterPanel"
      @openSummary="openSummary"
    />

    <!-- Harita Görünüm Değiştirme -->
    <MapViewToggle :mapView="$store.state.mapView" @toggle="mapstatus" />

    <!-- Yükleniyor Göstergesi -->
    <LoadingSystem :loading="load" />

    <!-- Ana Harita Bileşeni -->
    <MapContainer
      ref="mapContainer"
      :center="position"
      :zoom="zoomLevel"
      :mapTypeId="$store.state.mapView ? 'hybrid' : 'roadmap'"
      @mapClick="handleMapClick"
    >
      <!-- Bölge Paneli -->
      <ZoneDisplay
        v-if="showZones"
        :vehicles="originalVehicleList"
        :visible="showZones"
        :mapObject="gmapObject"
        @zoneSelected="handleZoneSelected"
        @zoneLoaded="handleZoneLoaded"
      />
      <!-- @vehicleSelected="handleVehicleSelected" -->

      <!-- Araç İşaretçileri -->
      <VehicleMarkers
        v-if="!selectedItem"
        :markers="markers"
        :selectedGroup="selectedGroup"
        :selectedFleet="selectedFleet"
        :filter="filter"
        @clusterClick="handleClusterMouseOver"
        @markerClick="showItemDetail"
      />

      <!-- Fabrika/Müşteri İşaretçileri -->
      <FactoryMarkers
        v-if="showFactories"
        :markers="vectorMarkers"
        @clusterClick="handleClusterMouseOver"
        @markerClick="showItemDetail"
      />

      <!-- Seçili Öğe ve Rota Gösterimi -->
      <SelectedItemDisplay
        v-if="selectedItem && selectedItem.plate"
        :selectedItem="selectedItem"
        :selectedActiveDetail="selectedActiveDetail"
        @markerClick="showItemDetail"
        @targetPointClick="zoomToTargetPoint"
      />
    </MapContainer>
  </div>
</template>

<script>
// Npm paketleri
import moment from "moment";

// Yerel Bileşenler

// özet modalı
import detailModal from "./components/Dialogs/summary/index.vue";

import SideBarItem from "./components/Dialogs/sidebar/index.vue";
import ProductSideBarItem from "./components/Dialogs/vehicleDetail/index.vue";
import FilterPanel from "./components/Dialogs/filter/index.vue";

import GroupDetailPanel from "./components/Dialogs/groupDetail/index.vue";
import ZoneDisplay from "./components/map/plannedRegions";
import LoadingSystem from "./components/spinner.vue";
import MapControls from "./components/map/MapControls.vue";
import MapViewToggle from "./components/map/MapViewToggle.vue";
import MapContainer from "./components/map/MapContainer.vue";
import VehicleMarkers from "./components/map/VehicleMarkers.vue";
import FactoryMarkers from "./components/map/FactoryMarkers.vue";
import SelectedItemDisplay from "./components/map/SelectedItemDisplay.vue";

// Servisler
import { trackingService } from "./services/api";
import { mapHelpers } from "./services/mapHelpers";

export default {
  name: "maps-page",
  components: {
    SideBarItem,
    ProductSideBarItem,
    FilterPanel,
    GroupDetailPanel,
    detailModal,
    ZoneDisplay,
    LoadingSystem,
    MapControls,
    MapViewToggle,
    MapContainer,
    VehicleMarkers,
    FactoryMarkers,
    SelectedItemDisplay,
  },
  data() {
    return {
      // Harita durumu
      position: { lat: 41.015137, lng: 28.97953 },
      zoomLevel: 5,

      // Veriler
      markers: [],
      vectorMarkers: [],
      originalVehicleList: [],

      // Seçim durumu
      selectedGroup: "",
      selectedFleet: "",
      selectedItem: null,

      // UI durumu
      hoverListType: "vehicle",
      showFactories: false,
      showZones: false,
      hoverList: [],
      load: false,

      // Filtre durumu
      filter: {
        region: { key: null, id: 1 },
        workStatus: 1,
        productId: null,
        productName: null,
        deliveryDate: { start: null, end: null },
        deliveryState: 1,
      },

      // Detay durumu
      selectedActiveDetail: {
        targetPoint: { lat: 0, lng: 0 },
        customer: "",
        polyline: [],
        state: 1,
      },

      // Arama durumu
      search: "",
      isSearch: false,

      // Müdahale durumu
      isIntervention: false,
      interventionList: [],

      detail: {},
      isVehicleDetailShow: false,
      gmapObject: null,

      // Diğer
      sync: {
        date: moment().fromNow(),
        state: false,
      },
      filterLoad: true,
      isRequestPending: true,
      needInterval: true,
    };
  },

  methods: {
    // Harita etkileşimleri
    handleZoneSelected(data) {
      this.hoverList = this.originalVehicleList.filter(
        (v) => v.polygonName == data.zone.name
      );
      this.hoverListType = "group";
      this.position = data.center;
      this.zoomLevel = data.zoom;
    },

    handleZoneLoaded(center) {
      if (this.showZones && center) {
        this.position = center;
        this.zoomLevel = 8;
      }
    },

    handleMapClick() {
      if (this.showZones && this.$refs.zoneMap) {
        this.$refs.zoneMap.selectedZone = null;
      }
    },

    // Panel kontrolleri
    backProduct() {
      this.selectedItem = null;
    },

    mapstatus() {
      this.$store.commit("toggleMapStatus");
    },

    toggleFactories() {
      this.resetItemDetail();
      this.$refs.prodDetail.hideModal();
      this.isVehicleDetailShow = false;
      this.showFactories = !this.showFactories;
    },

    toggleZones() {
      this.resetItemDetail();
      this.$refs.prodDetail.hideModal();
      this.isVehicleDetailShow = false;
      this.showZones = !this.showZones;
      if (this.showZones) {
        this.showFactories = false;
      }
    },


    // Detay işlemleri
    showItemDetail(item, type) {
      this.hoverList = [];
      
      // Her durumda zoom yap
      if (item && item.position) {
        this.position = { ...item.position };
        this.zoomLevel = 12; // Uygun zoom seviyesi
      }
      
      // Sadece araç tipi için seçili öğe ata
      if (type === "vehicle") {
        this.selectedItem = item;
        this.detail = item;
        this.selectedActiveDetail = {
          targetPoint: { lat: 0, lng: 0 },
          customer: "",
          polyline: [],
          state: 1,
        };
        
        if ("plate" in item) {
          this.$refs.prodDetail.showModal();
          this.isVehicleDetailShow = true;
        }
      } else if (type === "factory") {
        // Fabrika için sadece zoom yap, seçili öğe atanmaz
        this.selectedItem = null;
        this.detail = {};
        this.resetItemDetail();
        this.isVehicleDetailShow = false;
      }
    },

    resetItemDetail() {
      //this.isVehicleDetailShow=false;
      this.hoverList = [];
      this.selectedItem = null;
      this.selectedActiveDetail = {
        targetPoint: { lat: 0, lng: 0 },
        customer: "",
        polyline: [],
        state: 1,
      };
      // Rota geçmişini temizle
      this.showingRouteHistory = false;
      this.routeHistoryData = null;
      this.routeHistoryPolyline = [];
      this.routeHistoryActiveDetail = {
        targetPoint: { lat: 0, lng: 0 },
        customer: "",
        polyline: [],
        state: 1,
      };
    },

    // Küme işlemleri
    handleClusterMouseOver(cluster, type) {
      this.isVehicleDetailShow = false;
      if (typeof cluster.markers_ != "undefined") {
        this.hoverListType = type;
        this.hoverList = cluster.markers_.map((marker) => {
          return {
            ...marker,
            plate: marker.title,
          };
        });
      }
    },

    // Arama ve filtre
    performSearchOnEnter() {
      this.isSearch = true;
      this.hoverList = [];
      this.applyFilters();
      if (this.search == "") {
        this.isSearch = false;
      }
      if (this.selectedItem) {
        this.$refs.prodDetail.hideModal();
        this.isVehicleDetailShow = false;
        this.resetItemDetail();
      }
    },

    updateSearch(value) {
      this.search = value;
      if (value.length == 0) this.performSearchOnEnter();
    },

    updateFilters(newFilters) {
      this.filter = newFilters;
      this.applyFilters();
    },

    // Data yükleme
    async getAll(load = true) {
      this.load = load;
      try {
        const data = await trackingService.getAll(
          this.$store.state.userData.token
        );
        this.originalVehicleList = data;
        this.applyFilters();
      } catch (error) {
        console.error("Veri yüklenirken hata:", error);
      } finally {
        this.load = false;
        this.isRequestPending = false;
        this.filterLoad = false;
      }
    },
    async getAllVectors() {
      try {
        const data = await trackingService.getVectors(
          this.$store.state.userData.token
        );
        this.vectorMarkers = data.map((vectorItem) =>
          mapHelpers.mapVectorToMarker(vectorItem)
        );
      } catch (error) {
        console.error("Vektör verisi yüklenirken hata:", error);
      }
    },

    // Filtre uygulama
    async applyFilters() {
      let vehicleList = this.originalVehicleList;

      // Filtre ve grup seçimi
      if (this.selectedGroup === undefined) {
        this.selectedGroup = 0;
      }

      if (this.selectedFleet > 0 || this.selectedGroup > 0) {
        vehicleList = vehicleList.filter((vehicle) => {
          const hasMatchingFleet =
            this.selectedFleet === 0 || vehicle.fleetId === this.selectedFleet;

          const hasMatchingGroup =
            this.selectedGroup === 0 ||
            (Array.isArray(this.selectedGroup)
              ? this.selectedGroup.includes(vehicle.groupId)
              : vehicle.groupId === this.selectedGroup);

          return hasMatchingFleet && hasMatchingGroup;
        });
      }

      // Arama
      let list = this.isSearch
        ? await this.filterBySearch(vehicleList, this.search)
        : vehicleList;

      // Diğer filtreler ve marker'a dönüştürme
      this.markers = this.filterAndMapMarkers(list);

      // Seçili öğeyi güncelle
      if (this.markers.length > 0) {
        this.updateSelectedItem();
      } else {
        this.markers = [];
      }
    },

    filterBySearch(data, search) {
      const normalizedSearch = this.normalizeText(search);
      return data.filter(
        (item) =>
          this.normalizeText(item.vehicle).includes(normalizedSearch) ||
          this.normalizeText(item.driverName).includes(normalizedSearch) ||
          this.normalizeText(item.orderNo) === normalizedSearch ||
          (item.orderNos &&
            item.orderNos.some(
              (orderNo) => this.normalizeText(orderNo) === normalizedSearch
            )) ||
          (item?.planning.customer &&
            this.normalizeText(item.planning.customer).includes(
              normalizedSearch
            ))
      );
    },

    normalizeText(text) {
      return (
        text
          ?.toString()
          .toLocaleLowerCase("tr-TR")
          .replace(/[\u0300-\u036f\s]/g, "") || ""
      );
    },

    filterAndMapMarkers(list) {
      const {
        workStatus,
        productId,
        deliveryDate,
        deliveryState,
        productName,
        haveType       
      } = this.filter;

      return list
        .filter(
          (el) =>
            (!this.filter.region.key ||
              this.filter.region.key.toLowerCase().trim() ===
                el.region.toLowerCase().trim()) &&
            (workStatus === 1 || workStatus - 2 === Number(el.state)) &&
            (!productId ||
              mapHelpers.productController(el.productId, productName)) &&
            ((!haveType || haveType==3 )||
              mapHelpers.vehicleController(el.haveType, haveType)) &&
            (deliveryState === 1 ||
              mapHelpers.isDeliveryDateInRange(el.deliveryDate, deliveryDate))
        )
        .map((el) => mapHelpers.mapVehicleToMarker(el));
    },

    updateSelectedItem() {
      const selectedItem = this.markers.find(
        (item) => item.vehicle === this.selectedItem?.vehicle
      );

      this.selectedItem = selectedItem || this.selectedItem;
    },

    // Diğer metotlar
    getDetail(data) {
      setTimeout(() => {
        this.position = data.position;
        this.detail = data.isPirateDriver
          ? {
              ...data,
              outpointAdress: data.planning.outpointAdress,
              targetAdress: data.planning.targetAdress,
            }
          : data;
          this.zoomLevel = 12 ;
          this.$forceUpdate();
      }, 50);
    },

    setPlaqueSelected(val) {
      const markers =
        this.hoverListType === "vehicle" || this.hoverListType === "group"
          ? this.markers
          : this.vectorMarkers;
      const selectedMarker = markers?.find((r) => r.title.includes(val));
      
      // Her durumda zoom yap
      if (selectedMarker && selectedMarker.position) {
        this.position = { ...selectedMarker.position };
        this.zoomLevel = this.zoomLevel === 12 ? 13 : 12; // Uygun zoom seviyesi
      }
      
      // Sadece araç tipi için detay göster
      if (this.hoverListType === "vehicle" || this.hoverListType === "group") {
        this.selectedItem = {...selectedMarker};
        this.detail = {...selectedMarker};
        this.$refs.prodDetail.showModal();
        this.isVehicleDetailShow = true;
        this.getDetail(selectedMarker);
      } else if (this.hoverListType === "factory") {
        // Fabrika için seçili öğe atanmaz, sadece zoom yapılır
        this.selectedItem = null;
        this.detail = {};
        this.resetItemDetail();
        this.isVehicleDetailShow = false;
      }
    },
    // Event handler'lar
    handleFleetSelected(value) {
      this.selectedGroup = 0;
      this.selectedFleet = value;
    },
    handleGroupSelected(value) {
      this.selectedGroup = value;
    },

    updateActiveDetail(value) {
      this.selectedActiveDetail = value;
    },

    updateInterventionStatus(value) {
      this.isIntervention = value;
    },

    updateInterventionList(value) {
      this.interventionList = value;
    },

    openFilterPanel() {
      this.$refs.filterPanel.showModal();
    },

    openSummary() {
      this.$modal.show("planning-state-modal");
    },

    zoomToTargetPoint(targetPoint) {
      if (targetPoint && targetPoint.lat && targetPoint.lng) {
        this.position = { ...targetPoint };
        this.zoomLevel = 12; // Hedef noktaya uygun zoom seviyesi
      }
    },

    handleShowRouteOnMap(data) {
      if (!data || !data.locations || data.locations.length === 0) {
        return;
      }

      // Locations array'ini polyline formatına çevir ve unique noktaları filtrele
      const allPoints = data.locations.map(loc => ({
        lat: loc.latitude,
        lng: loc.longitude
      }));

      // Unique koordinatları filtrele (aynı noktayı tekrar ekleme)
      const polyline = [];
      let lastPoint = null;

      for (const point of allPoints) {
        if (!lastPoint ||
            Math.abs(point.lat - lastPoint.lat) > 0.00001 ||
            Math.abs(point.lng - lastPoint.lng) > 0.00001) {
          polyline.push(point);
          lastPoint = point;
        }
      }

      // Eğer sadece 1 unique nokta varsa (araç hareket etmemiş)
      if (polyline.length < 2) {
        alert('Bu tarihte araç hareket kayıtları bulunamadı. Araç aynı noktada durmuş görünüyor.');
        return;
      }

      // Rota geçmişi active detail'i set et (SelectedItemDisplay için)
      this.routeHistoryActiveDetail = {
        targetPoint: polyline[polyline.length - 1], // Son nokta
        customer: `${data.date} Rota Geçmişi`,
        polyline: polyline,
        state: 1,
      };

      // Rota geçmişi gösterimi aktif
      this.showingRouteHistory = true;
      this.routeHistoryData = data;

      // Haritayı rotaya zoom yap
      this.$nextTick(() => {
        if (polyline.length > 0) {
          // İlk ve son noktaya göre merkez ve zoom hesapla
          const bounds = new google.maps.LatLngBounds();
          polyline.forEach(point => bounds.extend(point));

          const center = bounds.getCenter();
          this.position = { lat: center.lat(), lng: center.lng() };

          // Zoom seviyesini bounds'a göre ayarla
          if (this.$refs.mapContainer) {
            const mapObject = this.$refs.mapContainer.getMapObject();
            if (mapObject) {
              mapObject.fitBounds(bounds);
              // Biraz daha zoom out yap ki tüm rota rahat görünsün
              setTimeout(() => {
                const currentZoom = mapObject.getZoom();
                if (currentZoom > 13) {
                  mapObject.setZoom(13);
                }
              }, 100);
            }
          }
        }
      });
    },
  },

  computed: {
    deviationMarkers() {
      return this.filterList().filter((m) => m.isDeviation);
    },

    nonDeviationMarkers() {
      return this.filterList().filter((m) => !m.isDeviation);
    },

    filterList() {
      if (this.isIntervention) return this.interventionList;
      else if (!this.selectedItem) return this.markers;
      else return [this.detail];
    },
  },

  created() {
    this.getAll();
    this.getAllVectors();
  },

  watch: {
    search(val) {
      if(val=="") this.performSearchOnEnter();
    },
    selectedItem(val) {
      if (!val) return;
      this.getDetail(val);
    },

    selectedFleet() {
      this.applyFilters();
    },

    selectedGroup() {
      this.applyFilters();
    },
  },
};
</script>